import { dateToString } from 'modules/core/lib/dates'
import { Collection } from 'modules/core/lib/mobx-rest'

import Cycle from 'modules/timeoff/store/models/Cycle'

class Cycles extends Collection<Cycle> {
  get cacheKey(): string {
    return 'cycles'
  }

  model() {
    return Cycle
  }

  fetchCycles(allowanceId: number, employeeId: number, referenceDate: moment.Moment): Promise<any> {
    return this.fetch({
      data: {
        id: allowanceId,
        employee_id: employeeId,
        reference_date: dateToString(referenceDate, 'backend'),
      },
    })
  }

  findByEffectiveOn(allowanceId: number, date: moment.Moment): Cycle | null | undefined {
    return this.find((cycle) => cycle.attributes.allowance_id === allowanceId && cycle.covers(date))
  }
}

const singleton: Cycles = new Cycles()

export default singleton
